<template>
  <div class="sheet">
    <!-- DRAG BAR -->
    <div class="drag-bar"></div>

    <div class="container-fluid h-100 p-0">
      <div class="row h-100 g-0">

        <!-- IMAGE AREA -->
        <div class="col-12 col-md-4 image-area">

          <!-- MAIN IMAGE -->
          <div class="main-img">
            <img :src="currentImage" />
          </div>

          <!-- THUMBNAILS -->
          <div class="thumb-list">
            <div v-for="(img, i) in images" :key="i" class="thumb" :class="{ active: img === currentImage }"
              @click="currentImage = img">
              <img :src="img" />
            </div>
          </div>

        </div>
        <div class="col-12 col-md-3 info-area">

          <div v-if="saleList.length" class="sale-box">
            <div class="sale-title " style="font-weight: 600; font-size: 18px;">🎁 Chọn mức chiết khấu:</div>

            <div class="sale-list">
              <div v-for="(s, i) in saleList" :key="i" class="sale-item" :class="{ active: selectedSale === s }"
                @click="selectedSale = s">
                <img class="sale-img w-100" :src="firstImage" />

                <div class="sale-text">
                  <div class="sale-title-text text-center">
                    Chiết khấu {{ s }}%
                  </div>
                  <div class="sale-sub-text text-center">
                    {{ saleRules[s] }}
                  </div>
                </div>
              </div>
            </div>

            <div v-if="selectedSale" class="final-price">
              <span class="old">
                {{ formatPrice(product.price) }}₫
              </span>
              <span class="new">
                {{ formatPrice(finalPrice) }}₫
              </span>
            </div>
          </div>
        </div>
        <!-- INFO AREA -->
        <div class="col-12 col-md-5 info-area">
          <div class="sheet-content">
            <h6 class="product-name">
              {{ product.name }}
            </h6>

            <div class="price">
              {{ product.price > 0 ? formatPrice(product.price) + '₫' : 'Liên hệ' }}
            </div>

            <p class="desc">
              {{ product.description }}
            </p>

            <p class="desc mt-5">
              {{ product.huongdan }}
            </p>
          </div>

          <!-- BUY BUTTON -->
          <div class="buy-bar" style="margin-bottom: 20px;">
            <button class="btn btn-danger w-100" @click="$emit('buy', product)">
              {{ formatPrice(displayPrice) }}₫ 🛒 Mua ngay
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,

    }
  },

  data() {
    return {
      currentImage: "",
      selectedSale: null

    };
  },

  computed: {
    images() {
      if (!this.product?.image) return [];
      return this.product.image.split(";").filter(i => i);
    },
    saleList() {
      if (!this.product?.sale) return [];
      return this.product.sale
        .split(";")
        .map(s => parseInt(s))
        .filter(s => !isNaN(s));
    },

    finalPrice() {
      if (!this.selectedSale) return this.product.price;
      return Math.round(
        this.product.price * (100 - this.selectedSale) / 100
      );
    },
    displayPrice() {
      return this.selectedSale
        ? this.finalPrice
        : this.product.price;
    },
    firstImage() {
      if (!this.product?.image) return "";
      return this.product.image.split(";")[0];
    },
    saleRules() {
      return {

        5: "5 – 20 cái",
        10: " 21 – 50 cái",
        15: " Trên 50 cái"
        // 20: "Trên 50 cái"
      };
    }
  },

  watch: {
    images: {
      immediate: true,
      handler(val) {
        if (val.length) this.currentImage = val[0];
      }
    }
  },

  methods: {
    formatPrice(v) {
      return v.toLocaleString("vi-VN");
    },

  }
};
</script>

<style scoped>
/* =========================
   BOTTOM SHEET
========================= */
.sheet {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 70vh;
  overflow: auto;
  background: #fff;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, .15);
  animation: slideUp .25s ease;
  z-index: 9999;
}

/* DRAG BAR */
.drag-bar {
  width: 40px;
  height: 4px;
  background: #ccc;
  border-radius: 2px;
  margin: 8px auto;
}

/* =========================
   IMAGE AREA
========================= */
.image-area {
  background: #fff;
}

.main-img {
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sale-box {
  margin-top: 12px;
}

.sale-title {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 6px;
}

.sale-list {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.sale-item {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  user-select: none;
}

.sale-item.active {
  border-color: #ee4d2d;
  color: #ee4d2d;
  font-weight: 600;
}

.sale-img {
  width: 60px;
  height: 60px;
  object-fit: contain;
  border-radius: 4px;
  background: #fff;
}

/* FINAL PRICE */
.final-price {
  margin-top: 8px;
}

.final-price .old {
  text-decoration: line-through;
  color: #999;
  font-size: 13px;
  margin-right: 8px;
}

.final-price .new {
  color: #ee4d2d;
  font-size: 18px;
  font-weight: bold;
}

.main-img img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 12px;
}

/* THUMBNAILS */
.thumb-list {
  display: flex;
  gap: 8px;
  padding: 8px 12px;
  overflow-x: auto;
  justify-content: center;
}

.thumb {
  width: 48px;
  height: 48px;
  border: 1px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  flex-shrink: 0;
}

.thumb.active {
  border-color: #ee4d2d;
}

.thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 6px;
}

/* =========================
   INFO AREA
========================= */
.info-area {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sheet-content {
  padding: 12px;
  overflow-y: auto;
  flex: 1;
}

.product-name {
  font-size: 17px;
  font-weight: 600;
}

.price {
  color: #ee4d2d;
  font-size: 18px;
  font-weight: bold;
  margin-top: 4px;
}

.desc {
  font-size: 13px;
  color: #555;
  white-space: pre-line;
  margin-top: 8px;
}

/* BUY BAR */
.buy-bar {
  padding: 10px;
  border-top: 1px solid #eee;
  background: #fff;
}

/* =========================
   DESKTOP
========================= */
@media (min-width: 768px) {
  .sheet {
    height: 50vh;
  }

  .main-img {
    height: 350px;
  }
}

/* =========================
   ANIMATION
========================= */
@keyframes slideUp {
  from {
    transform: translateY(100%);
  }

  to {
    transform: translateY(0);
  }
}
</style>
